export const highlightStyleOptions = {
  textColor: {
    black: {
      label: 'Black',
      value: 'black',
      displayValue: 'rgba(0, 0, 0, 1.0)',
    },
    white: {
      label: 'White',
      value: 'white',
      displayValue: 'rgba(255, 255, 255, 1.0)',
    },
    gray: {
      label: 'Gray',
      value: 'gray',
      displayValue: 'rgba(255, 255, 255, 0.5)',
    },
  },
  textSize: {
    small: {
      label: 'Small',
      value: 'small',
      displayValue: 16,
    },
    medium: {
      label: 'Medium',
      value: 'medium',
      displayValue: 24,
    },
    large: {
      label: 'Large',
      value: 'large',
      displayValue: 32,
    },
  },
  textPosition: {
    top: {
      label: 'Top',
      value: 'top',
    },
    middle: {
      label: 'Middle',
      value: 'middle',
    },
    bottom: {
      label: 'Bottom',
      value: 'bottom',
    },
  },
  backgroundColor: {
    black: {
      label: 'Black',
      value: 'black',
      displayValue: 'rgba(0, 0, 0, 1.0)',
    },
    white: {
      label: 'White',
      value: 'white',
      displayValue: 'rgba(255, 255, 255, 1.0)',
    },
    gray: {
      label: 'Gray',
      value: 'gray',
      displayValue: 'rgba(255, 255, 255, 0.5)',
    },
  },
};
